module.exports = __webpack_public_path__ + "static/media/day-planner.04134685.png";